export default __webpack_public_path__ + "static/Cipher-cf0cd97bda168624cfdd7eff5a9d8e0d.png";